import _ from 'lodash';
import initHelpers from '72cms-ui/helpers';
import env from '../../../cms/js/config/base';

const getHelpers = initHelpers(env);

const api = getHelpers('api');
const getImagePath = getHelpers('getImagePath');
const getAssetPath = getHelpers('getAssetPath');
const formatString = getHelpers('formatString');
const getGeolocation = getHelpers('getGeolocation');

_.mixin({
    imgPath: getImagePath,
    filePath: getAssetPath,
    str: formatString,
});

export default {
    computed: {
        _() {
            return _;
        },

        api() {
            return api;
        },
    },

    methods: {
        getGeolocation(address) {
            return getGeolocation(address);
        },

        __(value, format = null) {
            return formatString(value, format);
        },

        randomKey() {
            return Math.floor(Math.random() * 1000000);
        },

        serialize(value) {
            return JSON.stringify(value);
        },
    }
}

